import { Pipe, PipeTransform } from '@angular/core'
import * as lodash from 'lodash'
import { availableTemplateTypes } from './template.constants'
import { TemplateTypes } from './template-types'

@Pipe({
  name: 'templateIcon',
  standalone: false,
})
export class TemplateIconPipe implements PipeTransform {
  transform(value: TemplateTypes, color = false): string {
    const type = lodash.find(availableTemplateTypes, { id: value })
    if (color) {
      return `${type.icon} ${type.colorClass}`
    }

    return type.icon
  }
}
